import React from "react";
import Header from "~/components/Header";
import ModelView from "~/components/ModelView";
import ChatHistory from "~/components/chat/ChatHistory";
import ControlButton from "~/components/ControlButton";

interface ChatPageLayout3Props {
  isSettingOpen: boolean;
  isStandbymode: boolean;
}

const ChatPageLayout3: React.FC<ChatPageLayout3Props> = ({ isSettingOpen, isStandbymode }) => {
  return (
    <>
      <Header />
      <div className={`main-contents-layout-3 ${isSettingOpen ? "open" : ""}`}>
        <ModelView visible={!isStandbymode} />
        <div className="sub-contents-layout-3">
          <div className="chat-space">
            <div className="chat-container">
              <ChatHistory />
            </div>
          </div>
          <ControlButton />
        </div>
      </div>
    </>
  );
};

export default ChatPageLayout3;
